/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProductsJsmOrganizationsList from '@jira/admin-pages__products-jsm-organizations-list/src/OrganizationsListPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmOrganizations: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ProductsJsmOrganizationsList
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-organizations-list", jiraSpaEntry: "async-products-jsm-organizations-list" */ '@jira/admin-pages__products-jsm-organizations-list/src/OrganizationsListPage.tsx'
		),
	),
);

const AsyncProductsJsmOrganizations = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmOrganizations}
		pageId="products-jsm-organizations-list"
		shouldShowSpinner
	/>
);

export default AsyncProductsJsmOrganizations;
